import { initialMasterServicesState } from 'redux/initialState';

import { status } from 'constants/general';
import masterServicesActionTypes from './action-types';

const masterServicesReducer = (state = initialMasterServicesState, { type, payload }) => {
  switch (type) {
    case masterServicesActionTypes.FETCH_MASTERSERVICES_LIST:
      return {
        ...state,
        masterServicesList: {
          status: status.FETCHING,
        },
      };

    case masterServicesActionTypes.FETCH_MASTERSERVICES_LIST_SUCCESS:
      return {
        ...state,
        masterServicesList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case masterServicesActionTypes.FETCH_MASTERSERVICES_LIST_FAIL:
      return {
        ...state,
        masterServicesList: {
          status: status.FAIL,
        },
      };
    case masterServicesActionTypes.ADD_OR_EDIT_MASTER_SERVICE:
      return {
        ...state,
        addOrEditMasterService: {
          status: status.FETCHING,
        },
      };
    case masterServicesActionTypes.ADD_OR_EDIT_MASTER_SERVICE_SUCCESS:
      return {
        ...state,
        addOrEditMasterService: {
          status: status.SUCCESS,
        },
      };
    case masterServicesActionTypes.ADD_OR_EDIT_MASTER_SERVICE_FAIL:
      return {
        ...state,
        addOrEditMasterService: {
          status: status.FAIL,
          error: payload,
        },
      };
    case masterServicesActionTypes.RESET_ADD_OR_EDIT_MASTER_SERVICE:
      return {
        ...state,
        addOrEditMasterService: {
          ...initialMasterServicesState.addOrEditMasterService,
        },
      };
    case masterServicesActionTypes.DELETE_MASTER_SERVICE:
      return {
        ...state,
        deleteMasterService: {
          status: status.FETCHING,
        },
      };
    case masterServicesActionTypes.DELETE_MASTER_SERVICE_SUCCESS:
      return {
        ...state,
        deleteMasterService: {
          status: status.SUCCESS,
        },
      };
    case masterServicesActionTypes.DELETE_MASTER_SERVICE_FAIL:
      return {
        ...state,
        deleteMasterService: {
          status: status.FAIL,
          error: payload,
        },
      };
    case masterServicesActionTypes.RESET_DELETE_MASTER_SERVICE:
      return {
        ...state,
        deleteMasterService: {
          ...initialMasterServicesState.deleteMasterService,
        },
      };
    case masterServicesActionTypes.FETCH_CATEGORIES:
      return {
        ...state,
        categories: {
          status: status.FETCHING,
        },
      };

    case masterServicesActionTypes.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case masterServicesActionTypes.FETCH_CATEGORIES_FAIL:
      return {
        ...state,
        categories: {
          status: status.FAIL,
        },
      };
    default:
      return state;
  }
};

export default masterServicesReducer;
